// extracted by mini-css-extract-plugin
export default {"Gotop":"index_Gotop_v6Ldi"};